import * as React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { COUNTRIES } from "../../constants/countries";
import { Typography } from "@mui/material";

interface CountryPickerNewProps {
  label: string;
  value: string | undefined;
  setValue: Function;
}

const CountryPickerNew = (props: CountryPickerNewProps) => {
  const textStyle = {
    fontFamily: "Manrope",
    color: "#6f7d95",
    fontSize: "1rem !important",
  };

  const country = COUNTRIES.find((c) => c.label === props.value);

  return (
    <Autocomplete
      id="country-select-demo"
      fullWidth
      sx={{
        backgroundColor: "#f4f6f9 !important",
        ".MuiInputBase-input": {
          display: "flex",
          alignItems: "center",
          backgroundColor: "#f4f6f9 !important",
          borderRadius: "5px !important",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderWidth: "0px",
        },
        "& .MuiOutlinedInput-input": {
          fontFamily: "Manrope",
          color: "#6f7d95",
          fontSize: "1rem !important",
        },
      }}
      options={COUNTRIES}
      autoHighlight
      getOptionLabel={(option) => option.label}
      value={country !== undefined ? country : undefined}
      onChange={(event: any, newValue: any) => {
        props.setValue(newValue.label);
      }}
      renderOption={(props, option) => {
        const { ...optionProps } = props;
        return (
          <Box
            component="li"
            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
            {...optionProps}
          >
            <img
              loading="lazy"
              width="20"
              srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
              src={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png`}
              alt=""
            />
            <Typography variant="body1" sx={textStyle}>
              {option.label}
            </Typography>
          </Box>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          inputProps={{
            ...params.inputProps,
            autoComplete: "new-password", // disable autocomplete and autofill
          }}
        />
      )}
    />
  );
};

export default CountryPickerNew;
